import { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import ErrorLabel from "../error_label";
import {
  actionBulkUpload,
  resetBulkUpload,
} from "../../routes/app/auth/employer/store";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import $ from "jquery";
import { TOAST_DURATION, TOAST_POSITION, TOAST_SUCCESS_COLOR } from "../../common/app_constant";
import DownloadSampleDoc from "../download_sample_doc"
const BulkUpload = (props) => {
  const [attachment, setAttachment] = useState([]);
  const [adBulk, setAddBulk] = useState(false);
  const { BulkUpload } = useSelector((state) => ({
    ...state.employerStore,
  }));
  const {
    register,
    formState: { errors },
    handleSubmit,
    setValue,
    reset,
  } = useForm({
    defaultValues: {
      documents: null,
    },
  });
  const removeAll = () => {
    setAttachment([]);
  };
  const dispatch = useDispatch();

  const initialRender = () => {
    if (props.show === true) {
      $("#root").addClass("modal-open");
      $("#root").append('<div class="modal-backdrop fade show"></div>');
    } else {
      $("#root").removeClass("modal-open");
      $(".modal-backdrop").remove();
      reset();
      setAttachment([]);
    }
  };
  useEffect(initialRender, [props.show]);

  useEffect(() => {
    if (BulkUpload) {
      dispatch(resetBulkUpload());
      if (BulkUpload.status) {
        setAddBulk(false);
        props.handleUpdateList();
        toast.success(BulkUpload.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {
            color: TOAST_SUCCESS_COLOR,
          },
        });
      }else{
        toast.error(BulkUpload?.message, {
          duration: TOAST_DURATION,
          position: TOAST_POSITION,
          style: {},
        });
      }
    }
  }, [BulkUpload]);

  const onSubmit = () => {
    var files = [];
    if (attachment != null) {
      files.push({
        name: "file",
        value: attachment[0],
      });
    }
    dispatch(
      actionBulkUpload({
        files,
        module: props.module,
        dynamic_url: props.dynamic_url,
      })
    );
  };

  return (
    <>
      <div
        class="modal fade show"
        id="default"
        role="dialog"
        tabindex="-1"
        aria-labelledby="exampleModalLabel"
        aria-hidden="true"
        style={{ display: `${props.show === true ? "block" : "none"}` }}
      >
        <div class="modal-dialog modal-md modal-dialog-centered">
          <div class="modal-content">
            <div class="modal-header">
              <h6 class="modal-title" id="employerAddEdit">
                Bulk Update
              </h6>
              <button
                type="button"
                class="btn-close"
                data-bs-dismiss="modal"
                aria-label="Close"
                onClick={() => {
                  props.handleUpdateList();
                }}
              ></button>
            </div>
            <div class="modal-body">
              <div className="row">
                <div className="col-12 col-md-12 col-lg-12 col-xl-12">
                  <form
                    noValidate
                    autoComplete="Off"
                    onSubmit={handleSubmit(onSubmit)}
                  >
                    <div className="form-body">
                      <div className="row mb-3">
                        <div className="">
                          <label htmlFor="formFile" className="form-label">
                            Attachment<span className="text-danger">*</span>
                          </label>
                          <input
                            className="form-control"
                            type="file"
                            accept=".xlsx,.xls"
                            name="documents"
                            {...register("documents", {
                              required: "This is required."
                            })}
                            onChange={(event) => {
                              setAttachment(event.target.files);
                            }}
                          />
                          {errors.documents && (
                            <ErrorLabel message={errors.documents?.message} />
                          )}
                        </div>
                      </div>
                    </div>
                    <div className="form-actions border-0 float-none mt-1">
                      <div className="d-flex justify-content-between">
                      <div><button
                        id="edit_customer"
                        className="btn btn-primary shadow round text-uppercase me-2"
                        type="submit"
                      >
                        <div className="d-flex align-items-center">
                          Submit
                          <span
                            id="edit_customer-loader"
                            className="spinner-border spinner-border-sm ml-half d-none"
                          ></span>
                        </div>
                      </button>
                      <button
                        className="btn btn-outline-secondary mr-1 shadow round text-uppercase"
                        onClick={(event) => {
                          props.handleUpdateList();
                          event.preventDefault();
                        }}
                      >
                        {" "}
                        Cancel
                      </button>
                      </div>
                      <div className="my-auto">
                            <DownloadSampleDoc fileName={props.sampleFileName}/>
                      </div>
                      </div>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default BulkUpload;
